import React, { PureComponent } from "react"

import NavButton from "./nav-button"
import "./tab-container.css"

class TabContainer extends PureComponent {
  state = {
    activeTabIndex: 0,
  }

  onTabClick = index => {
    this.setState({ activeTabIndex: index })
  }

  render() {
    const { tabList = [], style, children } = this.props
    const { activeTabIndex } = this.state
    const activeTab = tabList[activeTabIndex]

    return (
      <div className="tab-container" style={style}>
        <ul className="nav-list">
          {tabList.map((item, index) => (
            <li key={`${item}-${index}`} onClick={() => this.onTabClick(index)}>
              <NavButton active={activeTabIndex === index}>{item}</NavButton>
            </li>
          ))}
        </ul>
        <div className="content-wrapper">
          <div className="content-header">
            <h3>{activeTab}</h3>
          </div>
          <div className="content-main">
            {React.Children.map(children, (child, index) => (
              <div
                style={{ display: activeTabIndex === index ? "block" : "none" }}
              >
                {child}
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default TabContainer
